import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
import { Tron } from './Tron';

export const ExcelOnline = () => {
  
  let homeTron = {
    title: 'Workspace ONE iOS Excel Online Add-In (Beta)',
    description: 'This is the installation documentation page for the Workspace ONE iOS Excel Online Add-In.',
    body: <>
      <p>This covers using this website to run the Add-In.</p>
      <p><b>However,</b> this is mostly for evaluation purposes since, for security and privacy reasons,
        there is no caching layer implemented at this time so your speed will be much higher
        with a <a href='./APIBackendWindows'>Caching API implemented</a></p>
      <p>This is easier than you think.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h4 id="copy-and-edit-manifest.xml">Copy and edit Manifest.xml</h4>
        <p>The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">VMware Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the manifest.xml to a temporary folder on your computer</p>
        <h5>Edit the manifest.xml</h5>
        <Image alt="Edit Manifest" width='800' src='../images/WSONEEditManifest.png' fluid/>
        <ul>
          <li>Right click on the manifest.xml and click edit</li>
          <li>Click Open the Edit menu and click Replace</li>
          <li>In "Find What" put /localhost/</li>
          <li>In "Replace With" put /wsonereporting.azurewebsites.net/</li>
          <li>Click "Replace All"</li>
          <li>Save your manifest.xml</li>
        </ul>
        
        <h4>Setup your Add-In</h4>
        <ul>
          
          <li>
            <p>Open <a href="https://office.live.com/" rel="nofollow">Microsoft Office on the web</a>.</p>
          </li>
          <li>
            <p>In Get started with the online apps now, choose Excel and then open a new document.</p>
          </li>
          <li>
            <p>Open the Insert tab on the ribbon and, in the Add-ins section, choose Office Add-ins.</p>
          </li>
          <li>
            <p>On the Office Add-ins dialog, select the MY ADD-INS tab, choose Manage My Add-ins, and then
              Upload My Add-in.</p>
            <img src="../images/WSOneOfficeAddInsInsertAddIn.png" alt="Insert Addin" height="500"/>
          </li>
          <li>
            <p>Browse to the add-in manifest file, and then select Upload.</p>
            <img src="../images/WSOneUploadAddIn.png" alt="Verify Addin" width="500"/>
          </li>
          <li>
            <p>Verify that your add-in is installed. It should appear on the ribbon. </p>
            <img src="../images/WSOneOnlineAddinInstalled.png" alt="Verify Addin" width="500"/>
          </li>
        </ul>
      
      </Container>
    </Container>
  );
};

